import 'mapbox-gl/dist/mapbox-gl.css';

import { Flex, Text } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useGlobalContext } from 'contexts/GlobalContext';
import PageNotFound from 'pages/admin/erros/pageNotFound';
import { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import Auth from './types/Auth';
import Blank from './types/Blank';
import Default from './types/Default';
import Plans from './types/Plans';
import Register from './types/Register';

// Custom Chakra theme
export default function Dashboard() {
	const { routes, pathCompanyName } = useGlobalContext();
	const location = useLocation();
	const getActiveRoute = routes => {
		const activeRoute = 'Default Brand Text';

		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				const collapseActiveRoute = getActiveRoute(routes[i].items);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else if (routes[i].category) {
				const categoryActiveRoute = getActiveRoute(routes[i].items);
				if (categoryActiveRoute !== activeRoute) {
					return categoryActiveRoute;
				}
			} else {
				if (
					routes[i].name.includes('Editar') &&
					window.location.href.includes(
						routes[i].layout + routes[i].editPath
					)
				) {
					return routes[i];
				} else if (
					window.location.href.indexOf(
						routes[i].layout + routes[i].path
					) !== -1
				) {
					return routes[i];
				}
			}
		}
		return activeRoute;
	};
	const TemplatesPage = {
		default: Default,
		blank: Blank,
		plans: Plans,
		auth: Auth,
		register: Register,
	};
	const [templateKey, setTeplateKey] = useState('default');
	const route = getActiveRoute(routes);
	useEffect(() => {
		setTeplateKey(route.templatePage || 'default');
	}, [route]);

	const getRoutes = routes => {
		return routes.map((prop, key) => {
			if (prop.layout === `/${pathCompanyName}`) {
				// 🔒 Retorno de rota para usuários autenticados e com permissões de acesso, caso queira validar permissões de acesso descomente o código abaixo e comente o return do código acima

				if (prop.visualization) {
					return (
						<Route
							route={prop.route}
							path={prop.layout + prop.path}
							component={prop.component}
							exact={true}
							key={key}
						/>
					);
				} else {
					return (
						<Route
							path={prop.layout + prop.path}
							component={() => {
								return (
									<Flex
										direction='column'
										pt={{ sm: '125px', lg: '75px' }}
									>
										<Card px='0px'>
											<Flex
												flexDirection={'row'}
												justifyContent={'center'}
												mt={'20px'}
												me={'20px'}
											>
												<Text>
													Você não tem permissão para
													acessar esta página.
												</Text>
											</Flex>
										</Card>
									</Flex>
								);
							}}
							exact={true}
							key={key}
						/>
					);
				}
			}
			if (prop.collapse) {
				return getRoutes(prop.items);
			}
			if (prop.category) {
				return getRoutes(prop.items);
			} else {
				return null;
			}
		});
	};
	if (route.path === '/' && location.pathname !== `${route.layout}/`) {
		return <PageNotFound />;
	}
	const Template = TemplatesPage[templateKey];
	return (
		<>
			<Switch>
				<Template route={route}>{getRoutes(routes)}</Template>
				<Redirect
					from={`/${pathCompanyName}`}
					to={`/${pathCompanyName}/cadastros/produto/produtos`}
				/>
			</Switch>
		</>
	);
}
